// src/hooks/useMe.js
// Profil courant, partagé. AppSidebar et UserMenu affichaient le même profil en
// refaisant chacun leur GET /api/me — un seul appel suffit.
import { useEffect, useState } from "react";
// URL absolue obligatoire : en chemin relatif, CRA proxifie vers le `proxy` du
// package.json (127.0.0.1:5000) au lieu de REACT_APP_API_URL → ECONNREFUSED.
import { API_ROOT } from "../api/api";

let cache = null;
let inflight = null;
const listeners = new Set();

function normalize(data) {
  if (!data || data.error) return null;
  return {
    username:
      data.username || data.name || (data.email ? String(data.email).split("@")[0] : "User"),
    email: data.email || "",
    plan: data.plan || "free",
    // Photo de profil du compte FullMargin. Le backend ne la renvoie pas
    // (encore) : on accepte les noms de champ usuels, l'avatar bascule tout seul
    // de l'initiale à la photo dès que /api/me en expose une.
    photo:
      data.photo ||
      data.photoUrl ||
      data.avatar ||
      data.avatarUrl ||
      data.picture ||
      data.profileImage ||
      data.profilePicture ||
      "",
  };
}

function load() {
  if (cache) return Promise.resolve(cache);
  if (inflight) return inflight;

  const token = (() => {
    try {
      return localStorage.getItem("jwt_token");
    } catch {
      return null;
    }
  })();

  inflight = fetch(`${API_ROOT}/me`, {
    credentials: "include",
    headers: { Accept: "application/json", ...(token ? { Authorization: `Bearer ${token}` } : {}) },
  })
    .then((r) => (r.ok ? r.json() : null))
    .then((data) => {
      cache = normalize(data);
      listeners.forEach((fn) => fn(cache));
      return cache;
    })
    .catch(() => null)
    .finally(() => {
      inflight = null;
    });

  return inflight;
}

export default function useMe() {
  const [user, setUser] = useState(cache);

  useEffect(() => {
    let alive = true;
    const onChange = (u) => alive && setUser(u);
    listeners.add(onChange);
    load().then((u) => alive && setUser(u));
    return () => {
      alive = false;
      listeners.delete(onChange);
    };
  }, []);

  const initials = (user?.username || "U").slice(0, 2).toUpperCase();
  return { user, initials };
}

export function logout() {
  try {
    localStorage.removeItem("jwt_token");
  } catch {}
  window.location.href = "https://fullmargin.net";
}
